import { render } from "./MiniBusinessList.vue?vue&type=template&id=d7044000&ts=true"
import script from "./MiniBusinessList.vue?vue&type=script&lang=ts"
export * from "./MiniBusinessList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__